import { TextSelection } from 'prosemirror-state';
export function toggleCodeBlock(state, schema) {
  let sel = state.selection;
  let range = sel.$from.blockRange(sel.$to);
  if (!range) {
    return null;
  }
  if (sel.$head.sameParent(sel.$anchor) && sel.$head.parent.type === schema.nodes.codeBlock) {
    return convertSelectedCodeBlockToParagraphs(range, state, schema);
  } else {
    return convertSelectedParagraphsToCodeBlock(range, state, schema);
  }
}
function convertSelectedCodeBlockToParagraphs(range, state, schema) {
  // keep track of where the selection started relative to the
  // number of characters from the start and end nodes
  let sel = state.selection;
  let startDiff = sel.$from.pos - sel.$from.start();
  let endDiff = sel.$to.end() - sel.$to.pos;

  // get the text representation of the selected code block
  // where each <br> is a \n
  let text = codeBlockToText(schema, sel.$head.parent);

  // convert the lines of text of the code block into paragraphs, one per line
  let lines = text.split('\n');
  let paragraphs = lines.map(line => {
    let content = [];
    if (line) {
      content = [schema.text(line)];
    }
    return schema.nodes.paragraph.createAndFill({}, content);
  });

  // replace the range with the new paragraphs
  let tr = state.tr;
  tr.replaceWith(range.start, range.end, paragraphs);

  // maintain the original selection
  // the range starts before the first <p> so we start + 1
  // and each additional <p> adds 1 to the index
  //
  // 0   1 2 3 4 5
  //  <p> s o m e </p>
  // 6   7 8 9 10 11
  //  <p> t e x t  </p>
  tr.setSelection(TextSelection.create(tr.doc, range.start + 1 + startDiff, range.start + 1 + text.length + (paragraphs.length - 1) - endDiff));
  return tr;
}
function convertSelectedParagraphsToCodeBlock(range, state, schema) {
  // keep track of where the selection started relative to the
  // number of characters from the start and end nodes
  let sel = state.selection;
  let startDiff = sel.$from.pos - sel.$from.start();
  let endDiff = sel.$to.end() - sel.$to.pos;

  // get the text representation of the selected nodes
  // including blank lines (which don't come out of textBetween)
  let lines = [];
  state.doc.nodesBetween(range.start, range.end, node => {
    if (node.type === schema.nodes.codeBlock) {
      let text = codeBlockToText(schema, node);
      text.split('\n').forEach(line => {
        lines.push(line);
      });
    } else if (node.isTextblock) {
      lines.push(node.textContent);
    }
  });

  // turn the lines of text into a single code block, with each line
  // being text and a hard break (br)
  let content = lines.reduce((content, line, index) => {
    if (index !== 0) {
      content.push(schema.nodes.hardBreak.createAndFill());
    }
    if (line) {
      content.push(schema.text(line));
    }
    return content;
  }, []);
  let codeBlock = schema.nodes.codeBlock.createAndFill({}, content);

  // replace the range with a new code block
  let tr = state.tr;
  tr.replaceWith(range.start, range.end, codeBlock);
  let text = lines.join('');

  // maintain the original selection
  // the range starts before the first <pre> so we start + 1
  // and each additional <br> adds 1 to the index
  //
  // 0     1 2 3 4 5
  //  <pre> s o m e <br>
  // 6 7 8 9 10
  //  t e x t </pre>
  tr.setSelection(TextSelection.create(tr.doc, range.start + 1 + startDiff, range.start + 1 + text.length + (lines.length - 1) - endDiff));
  return tr;
}
function codeBlockToText(schema, node) {
  let text = '';
  node.forEach(node => {
    if (node.type === schema.nodes.hardBreak) {
      text += '\n';
    } else if (node.isText) {
      text += node.textContent;
    }
  });
  return text;
}